import React from 'react';
import { AdminRouteName } from '../../CONSTANTS';
import CustomerTableRecords from '../CustomerTableRecords';

const ActiveCustomers = () => (
  <CustomerTableRecords defaultUrl={AdminRouteName.activeCustomersRoute} toggleStorageId="all_customer-table-col" hasNameAndImage permissionName="can-view-all-customer-tab" tabStatus="active" />
);
export default ActiveCustomers;
